
import { lazy } from 'react';

// Páginas principales
export const Dashboard = lazy(() => import('@/pages/Index'));
export const Users = lazy(() => import('@/pages/Users'));
export const Departments = lazy(() => import('@/pages/Departments'));
export const KPIs = lazy(() => import('@/pages/KPIs'));
export const Reports = lazy(() => import('@/pages/Reports'));
export const Settings = lazy(() => import('@/pages/Settings'));
export const Profile = lazy(() => import('@/pages/Profile'));
export const CompanySettings = lazy(() => import('@/pages/BrandingSettings'));

// Páginas de autenticación
export const Login = lazy(() => import('@/pages/Login'));
export const Register = lazy(() => import('@/pages/Register'));
export const ForgotPassword = lazy(() => import('@/pages/ForgotPassword'));
export const ResetPassword = lazy(() => import('@/pages/ResetPassword'));
export const AccessRequests = lazy(() => import('@/pages/admin/AccessRequests'));

// Páginas de error
export const NotFound = lazy(() => import('@/pages/NotFound'));

// Página de diagnóstico
export const Diagnostic = lazy(() => import('@/pages/diagnostic')); 
